var _mask, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mobileMenuIcon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1a1 1 0 011-1h21a1 1 0 110 2H1a1 1 0 01-1-1zm0 6a1 1 0 011-1h16a1 1 0 110 2H1a1 1 0 01-1-1zm1 5a1 1 0 100 2h18a1 1 0 100-2H1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1-2a3 3 0 00-3 3h4a1 1 0 01-1 1v-4zm21 0H1v4h21v-4zm3 3a3 3 0 00-3-3v4a1 1 0 01-1-1h4zm-3 3a3 3 0 003-3h-4a1 1 0 011-1v4zM1 4h21V0H1v4zm-3-3a3 3 0 003 3V0a1 1 0 011 1h-4zm3 3a3 3 0 00-3 3h4a1 1 0 01-1 1V4zm16 0H1v4h16V4zm3 3a3 3 0 00-3-3v4a1 1 0 01-1-1h4zm-3 3a3 3 0 003-3h-4a1 1 0 011-1v4zM1 10h16V6H1v4zm-3-3a3 3 0 003 3V6a1 1 0 011 1h-4zm4 6a1 1 0 01-1 1v-4a3 3 0 00-3 3h4zm-1-1a1 1 0 011 1h-4a3 3 0 003 3v-4zm18 0H1v4h18v-4zm-1 1a1 1 0 011-1v4a3 3 0 003-3h-4zm1 1a1 1 0 01-1-1h4a3 3 0 00-3-3v4zM1 14h18v-4H1v4z",
    fill: "url(#mobileMenuIcon_svg__paint0_linear)",
    mask: "url(#mobileMenuIcon_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobileMenuIcon_svg__paint0_linear",
    x1: 23,
    y1: 14,
    x2: 0,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2091EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#1A9DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#0DBCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D6B9"
  })))));
}

export default SvgMobileMenuIcon;